globalThis.appVisitor = globalThis.appVisitor || {};
appVisitor.config = appVisitor.config || {};

// Request-specific values are kept out of cached container fragments and injected here, before any form initialization.
appVisitor.hydrateRequestContextInputs = function($html) {
  var requestReferer = appVisitor.config.requestReferer,
      sourcePageUrl  = appVisitor.config.sourcePageUrl;

  if(requestReferer) $html.find('[data-request-referer-input]').val(requestReferer);
  if(sourcePageUrl) $html.find('[data-source-page-url-input]').val(sourcePageUrl);
}

appVisitor.initElements = function($html) {
  appVisitor.hydrateRequestContextInputs($html);

  var $sliders = $html.find('.element-slider');
  if($sliders.length) {
    appVisitor.ElementSlider.bindEvents();
    $sliders.each(function() {
      var slider = new appVisitor.ElementSlider($(this));
      slider.init();
    });
  }

  $html.find('.element-rss').each(function() {
    var rss = new appVisitor.ElementRss($(this));
    rss.init();
  });

  if($("body").hasClass("view-visitor") && appVisitor.config.analyticsEventsType.length) {
    $html.find('.analytics-events-onclick').each(function() {
      var click_event = new appVisitor.AnalyticsClickEvent($(this));
    });
  }

  $html.find('.element-form-standard, .element-form-advanced, .element-lead-generation-form').each(function() {
    var form = appVisitor.ElementForm.initObject($(this));
    form.init();
  });

  $html.find('.element-image.element-image-enlarge').each(function() {
    var image = new appVisitor.ElementImage($(this));
  });

  $html.find('.element-review-form').each(function() {
    var review_form = new appVisitor.ElementReviewForm($(this));
  });

  $html.find('.element-newsletter').each(function() {
    var newsletter = new appVisitor.ElementNewsletter($(this));
  });

  // Anchor desktop
  $html.find('.content-link-anchor').closest('.element').each(function() {
    var $menu = $(this);

    $menu.onePageNav({
      currentClass: 'selected',
      changeHash: true,
      scrollSpeed: 300,
      navItems: 'a.content-link-anchor',
      tabItem: 'li.menu-tab-container',
      currentParentClass: 'subselected',
      scrollChange: function($currentItem) {
        $menu.find(".content-link-anchor").removeAttr("aria-current");
        $currentItem.find("a").attr("aria-current", "location");
      }
    });
  });

  // Anchor mobile
  $html.find('.content-link-anchor').closest('nav.menu-mobile').each(function() {
    $(this).onePageNav({
      currentClass: 'selected',
      changeHash: true,
      scrollSpeed: 300,
      navItems: 'a.content-link-anchor',
      tabItem: 'li.menu-mobile-element',
      currentParentClass: 'subselected'
    });
  });

  $html.find('.element-hours').each(function() {
    var businessHours = new appVisitor.ElementBusinessHours($(this));
  });

  $html.find('.element-partner').each(function() {
    var partners  = new appVisitor.ElementPartner($(this));
    partners.init();
  });

  $html.find('.element-blog-element-last-article').each(function() {
    var ElementBlogLastArticle  = new appVisitor.ElementBlogLastArticle($(this));
    ElementBlogLastArticle.init();
  });

  $html.find('.element-review-display').each(function() {
    var reviewDisplays = new appVisitor.ElementReviewDisplay($(this));
    reviewDisplays.init();
  });

  $html.find('.element-tabs-container').each(function() {
    var tabsContainer = new appVisitor.ElementTabsContainer($(this));
    tabsContainer.init();
  });

  $html.find('.element-toggle-container').each(function() {
    var ElementToggleContainer = new appVisitor.ElementToggleContainer($(this));
    ElementToggleContainer.init();
  });

  $html.find('.element-sb-pricing-table').each(function() {
    var sbPricingTable = new appVisitor.ElementSbPricingTable($(this));
    sbPricingTable.init();
  });

  $html.find('.element-sb-pricing-detailed-table').each(function() {
    var sbPricingDetailedTable = new appVisitor.ElementSbPricingDetailedTable($(this));
    sbPricingDetailedTable.init();
  })

  $html.find('.element-sb-pricing-multiple-products-widget').each(function() {
    var sbPricingMultipleProductsWidget = new appVisitor.ElementSbPricingMultipleProductsWidget($(this));
    sbPricingMultipleProductsWidget.init();
  });

  $html.find('.element-sb-pricing-overview').each(function() {
    var sbPricingOverview = new appVisitor.ElementSbPricingOverview($(this));
    sbPricingOverview.init();
  })

  $html.find('.element-file').each(function() {
    var file = new appVisitor.ElementFile($(this));
    file.init();
  });

  $html.find('.element-instagram-feed').each(function() {
    var element = new appVisitor.ElementInstagramFeed($(this));
    element.init();
  });

  $html.find('.element-sb-last-customer-reviews').each(function() {
    var element = new appVisitor.SbElementLastCustomerReviews($(this));
    element.init();
  });

  $html.find('.element-sb-last-testimonial-videos').each(function () {
    var element = new appVisitor.SbElementLastTestimonialVideos($(this));
    element.init();
  });

  $html.find('.element-sb-local-management-platforms').each(function() {
    var element = new appVisitor.SbElementLocalManagementPlatforms($(this));
    element.init();
  });

  $html.find('.element-sb-websites-design-showroom').each(function() {
    var element = new appVisitor.SbElementWebsitesDesignShowroom($(this));
    element.init();
  });

  $html.find('.element-figure.display-animated').each(function() {
    var figure = new appVisitor.ElementFigure($(this));
  });

  $html.find('.element-faq').each(function() {
    var faq = new appVisitor.ElementFaq($(this));
    faq.init()
  });

  $html.find('.element-paypal-button').each(function() {
    var element = new appVisitor.ElementPaypalButton($(this));
    element.init();
  });

  $html.find('.element-before-after-slider').each(function() {
    var element = new appVisitor.ElementBeforeAfterSlider($(this));
    element.init();
  });

  $html.find('.element-menu').each(function() {
    var menu = new appVisitor.ElementMenu($(this));
    menu.init();
  });

  var $socialActionButtonsGroups = $html.find('.element-social-action-buttons-group');

  $socialActionButtonsGroups.each(function() {
    var socialActionButtonsGroup = new appVisitor.ElementSocialActionButtonsGroup($(this));
    socialActionButtonsGroup.setCurrentPageUrl();
  });

  if(!appVisitor.config.lazyloadEnabled) {
    $html.find('.element-album').each(function() {
      var album = new appVisitor.ElementAlbum($(this));
    });

    $socialActionButtonsGroups.each(function() {
      var elementSocialActionButtonsGroup = new appVisitor.ElementSocialActionButtonsGroup($(this));
      elementSocialActionButtonsGroup.init();
    });
  }

  if ($html.find('.floating-menu').length) {
    var $menu = $html.find('.floating-menu');
    var floatingMenu = new appVisitor.FloatingMenu($menu);
    floatingMenu.init();
  }

  $html.find('.background-video-background').each(function() {
    var backgroundVideo = new appVisitor.BackgroundVideo($(this));
    backgroundVideo.init();
  });
}

appVisitor.initPlugins = function($html)
{
  $html.sbCheckbox({ framework : 'vi' });
  $html.sbRadio({ framework : 'vi' });
  $html.find('.sb-vi-select').each(function(){
    $(this).selectForm({ framework : 'vi' });
  });
}

appVisitor.Router = (function()
{
  function Router() { }

  Router.prototype = {
    getAdminContext: function() {
      var regex   = /\/site\/.+?\/(.+?)(\/.*|$)/,
          urlPath = window.location.pathname,
          results = urlPath.match(regex);
      return (results) ? results[1] : '';
    },
    isContextContent: function() {
      return this.getAdminContext() === 'content';
    },
    isContextPages: function() {
      return this.getAdminContext() === 'pages';
    },
    isContextAdminVisitorView: function() {
      return this.getAdminContext() === 'visitor_view';
    }
  }
  return Router;
})();

$(document).on('ready page:load', function() {
  appVisitor.initPlugins($("body"));

  appVisitor.apiRoutePrefixPath = typeof(appAdmin) != 'undefined' ? '/site/' + appAdmin.config.version_key : '';

  var routerVisitor = new appVisitor.Router();
  var stickedFooter = new appVisitor.StickedFooter();
  var shortcuts     = new appVisitor.KeyboardShortcuts();
  var cookiesUsage  = new appVisitor.CookiesUsage();

  if(appVisitor.config.linkOpenConversionsTrackingEnabled || appVisitor.config.phoneNumberDisplayConversionsTrackingEnabled) {
    appVisitor.Conversionable = new appVisitor.modules.Conversionable();
  }

  appVisitor.ScrollToAnchor.init();

  appVisitor.Popup.initPopups();

  appVisitor.TopBar = appVisitor.TopBar.init();

  appVisitor.OptIn.init();

  if (!$('.floating-menu.bottom-right').length) {
    appVisitor.backToTop  = new appVisitor.BackToTop($('#backtotop')).init();
  }

  appVisitor.fixed_bloc = new appVisitor.FixedBloc($('body.aside_fixed .aside > .sections-container'), $('#center')).init();

  appVisitor.Animations.init();

  appVisitor.initElements($('body'));

  if ($('#blog-article-page').length) {
    var commentsController = new appVisitor.blog.commentsController($('.blog-article-comments-wrapper'));
    commentsController.init();

    var likesController = new appVisitor.blog.likesController($('.blog-article-likes'));
    likesController.init();

    var actionsController = new appVisitor.blog.actionsController($('.blog-article-actions'));
    actionsController.init();

    var shareEventsController = new appVisitor.blog.shareEventsController($('.blog-article-page-social-media-share-buttons'));
    shareEventsController.init();
  }
});

$(window).on('load', function() {
  (_axcb = window._axcb || []).push(function(sdk) {
    sdk.on('cookies:complete', function(choices){
      $('template[data-requires-vendor-consent]').each(function() {
        var $template = $(this),
            vendor = $template.data('requires-vendor-consent');

        if(choices[vendor]) {
          $template.replaceWith($($template.html().trim()));
        }
      });
    })
  });

  ImageQueries.init();

  var $videos = $('.element-video');

  if($videos.length) {
    var videoEventsListener = new appVisitor.ElementVideo.EventsListener();
  }

  if(appVisitor.config.lazyloadEnabled) {
    appVisitor.LazyLoader.lazyLoad();
  } else {
    ImageQueries.refresh();

    setTimeout(function() {
      if($videos.length) {
        $videos.each(function() {
          var video = new appVisitor.ElementVideo($(this));
        });
      }

      $('.element-map-standard .map-container').each(function() {
        var map = new appVisitor.ElementMapStandard($(this));
        map.init();
      });

      $('.element-map-advanced .map-container').each(function() {
        var map = new appVisitor.ElementMapAdvanced($(this));
        map.init();
      });

      $('.element-map-itinerary .map-container').each(function() {
        var map = new appVisitor.ElementMapItinerary($(this));
        map.init();
      });
    }, 1000);
  }
});
